import { useState } from "react";
import { useNavigate } from "react-router-dom";

import classes from "./SearchBar.module.css";

function SearchBar() {
  const navigate = useNavigate();

  const [keyword, setKeyword] =
    useState("");

  const submitHandler = (e) => {
    e.preventDefault();

    const query = keyword.trim();

    if (!query) return;

    navigate(
      `/search?q=${encodeURIComponent(
        query
      )}`
    );
  };

  return (
    <div className={classes.search_wrap}>
      <form
        className={classes.search_box}
        onSubmit={submitHandler}
      >
        <input
          type="text"
          placeholder="Search products..."
          className={classes.search_input}
          value={keyword}
          onChange={(e) =>
            setKeyword(e.target.value)
          }
        />

        <button
          type="submit"
          className={
            classes["search-box_button"]
          }
        >
          <ion-icon
            data-muradi-ico="search_ico"
            name="search-outline"
          />
        </button>
      </form>
    </div>
  );
}

export default SearchBar;

// import React from "react";
// import classes from "./SearchBar.module.css";
// const SearchBar = () => {
//   return (
//     <div className={classes["search_wrap"]}>
//       <form className={classes["search_box"]}>
//         <input
//           type="text"
//           className={classes["search_input"]}
//           placeholder="Search in muradi"
        
//         />
//         <button className={classes["search-box_button"]}>
//           <ion-icon data-muradi-ico="search_ico" name="search-outline" />
//         </button>
//       </form>

//     </div>
//   );
// };

// export default SearchBar;
